import {
  Address,
  Doctor,
  DoctorAddressVM,
  DoctorInsurance,
  DoctorNotePostResult,
  DoctorPostResult,
  DoctorResolve,
  MAGNotePostResult,
  PNInformationResolve,
  ProgramOrServices,
  Role,
  SelectVM,
  SignUpForm,
  SpResult,
  UpdateEntityStatus,
  UserIdentity,
  UserInsurance,
  InsuranceSupervisorInsurance,
  UserVM
} from '@/models'
import axios, { AxiosResponse } from 'axios'
import PNInformation from '../smartPN/PNInformation.vue'
const API_URL = 'Doctors'

export const getDoctors = async (
  pageNumber = 1,
  pageSize = 10,
  searchQuery = ''
): Promise<AxiosResponse<Doctor[]>> => {
  const response = await axios.get<Doctor[]>(
    API_URL +
      `?pageNumber=${pageNumber}&pageSize=${pageSize}&SearchQuery=${searchQuery}`
  )
  return response || null
}

export const getResolve = async (isDoctor = false): Promise<DoctorResolve> => {
  const { data } = await axios.get<DoctorResolve>(API_URL + `/DoctorsResolve`)
  if (isDoctor) {
    data.roles = data.roles.filter(c => c.label == Role.DoctorStaff)
    //console.log(data.roles)
  }
  return data
}

export const getGenders = async (): Promise<SelectVM[]> => {
  const { data } = await axios.get<SelectVM[]>(`Misc/Genders`)
  return data
}

export const getProgramOrServices = async (
  documentId: string
): Promise<ProgramOrServices[]> => {
  const { data } = await axios.get<ProgramOrServices[]>(
    API_URL + `/DoctorsProgramOrServices?documentId=${documentId.toString()} `
  )
  return data
}
export const getDoctorInfo = async (
  record: string
): Promise<PNInformationResolve> => {
  const { data } = await axios.get<PNInformationResolve>(
    `Forms/GetPNInformation?recordID=${record} `
  )
  return data
}
export const getDoctorAddresses = async (
  doctorId: string
): Promise<Address[]> => {
  const { data } = await axios.get<Address[]>(
    API_URL + `/GetDoctorAddresses?doctorId=${doctorId}`
  )
  return data
}
export const getDoctorInsurances = async (
  doctorId: number
): Promise<DoctorInsurance[]> => {
  const { data } = await axios.get<DoctorInsurance[]>(
    API_URL + `/GetDoctorInsurances?doctorId=${doctorId}`
  )
  return data
}
export const getUserInsurances = async (
  rmtUserId: number
): Promise<UserInsurance[]> => {
  const { data } = await axios.get<UserInsurance[]>(
    API_URL + `/getUserInsurances?rmtUserId=${rmtUserId}`
  )
  return data
}
export const getInsuranceSupervisorInsurances = async (
  rmtUserId: number
): Promise<InsuranceSupervisorInsurance[]> => {
  const { data } = await axios.get<InsuranceSupervisorInsurance[]>(
    API_URL + `/GetInsuranceSupervisorInsurances?rmtUserId=${rmtUserId}`
  )
  return data
}
export const getStaffDoctors = async (): Promise<UserIdentity[]> => {
  const { data } = await axios.get<UserIdentity[]>(API_URL + `/GetStaffDoctors`)
  return data
}

export const updateDoctorStatus = async (
  model: UpdateEntityStatus
): Promise<UpdateEntityStatus> => {
  const { data } = await axios.put<UpdateEntityStatus>(
    API_URL + `/UpdateDoctorStatus`,
    model
  )
  return data
}
export const updateDoctor = async (model: UserVM): Promise<UserVM> => {
  const { data } = await axios.put<UserVM>(API_URL + `/UpdateDoctor`, model)
  return data
}
export const postDoctor = async (model: UserVM): Promise<DoctorPostResult> => {
  const { data } = await axios.post(API_URL, model)
  return data
}

export const deleteDoctorAddress = async (
  model: DoctorAddressVM
): Promise<SpResult> => {
  const { data } = await axios.post(API_URL + `/DeleteDoctorAddress`, model)
  return data
}
export const signUp = async (model: SignUpForm): Promise<DoctorPostResult> => {
  const { data } = await axios.post(API_URL, model)
  return data
}

export const postDoctorNote = async (
  recordId: string,
  doctorNotes: string | null
): Promise<DoctorNotePostResult> => {
  const { data } = await axios.post(API_URL + `/CreateDoctorNote`, {
    RecordID: recordId,
    DoctorNotes: doctorNotes
  })
  return data
}

export interface UserBulkProgress {
  total: number
  created: number
  failed: number
  remaining: number
  completed: boolean
  error: string | null
}

export interface UserBulkRowResult {
  row: number
  documentId: string
  firstName: string
  lastName: string
  role: string
  result: string
  error: string | null
}

export const postUserBulk = async (
  file: FormData
): Promise<{ uploadId: string; total: number }> => {
  const { data } = await axios.post(API_URL + '/Bulk', file, { timeout: 0 })
  return data
}

export const getUserBulkProgress = async (
  uploadId: string
): Promise<UserBulkProgress> => {
  const { data } = await axios.get<UserBulkProgress>(
    API_URL + '/BulkProgress',
    {
      params: { uploadId },
      headers: { 'X-Skip-Loading': '1' }
    }
  )
  return data
}

export const getUserBulkResults = async (
  uploadId: string
): Promise<UserBulkRowResult[]> => {
  const { data } = await axios.get<UserBulkRowResult[]>(
    API_URL + '/BulkResults',
    { params: { uploadId } }
  )
  return data
}

export const postMAGNote = async (
  recordId: string,
  MAGNotes: string | null
): Promise<MAGNotePostResult> => {
  const { data } = await axios.post(API_URL + `/CreateMAGNote`, {
    RecordID: recordId,
    MAGNotes: MAGNotes
  })
  return data
}
